import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=842d2fa8&scoped=true"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"
import style0 from "./CardBody.vue?vue&type=style&index=0&id=842d2fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842d2fa8",
  null
  
)

export default component.exports